import React from 'react';
import IHome from '../interfaces/IHome';

import Config from '../utils/Config';
import Translate from '../utils/Translate';
import styles from './HomeCardSmall.scss';
import FavouriteIcon from './FavouriteIcon';
import searchApi from '../utils/searchApi';
import User from '../utils/User';
import Responsive from '../utils/Responsive';
import withUserHOC, { IUserState } from '../stores/withUser';
import OffMarketSvg from '../assets/img/off_market.svg';

const baseUrl = Config.get('baseUrl');
const placeholder = '-';


export interface IHomeCardSmallProps {
    data: IHome;
    isActive?: boolean;
    isVisible?: boolean;
    className?: string;

    user: IUserState;
    browserAffiliate: string;
}

export interface IHomeCardSmallState { }

class HomeCardSmall extends React.Component<IHomeCardSmallProps, IHomeCardSmallState> {
    render() {
        const home = this.props.data;

        const { isActive, user, browserAffiliate } = this.props;

        const isVisible = this.props.isVisible !== false;

        // const imgSrc = home.offMarket ? (user.isPremium ? baseUrl + home.image.path : offMarketSvg.src) : baseUrl + home.image.path;

        // build text for type and location
        let typeAndLocationText = `${home.propertyTypeText ? home.propertyTypeText : home.propertyType || ''} ${home.propertyTypeText && home.propertyType ? ' in ' : ''
            } ${home.locationText || ''}`;

        // use 'Haus' instead of 'Einfamilienhaus freistehend'
        if (Responsive.getWidth() < 600 && typeAndLocationText.length > 35) {
            typeAndLocationText = `${home.propertyType ? Translate.get(home.propertyType + 'Short') : ''} ${home.propertyType && home.propertyType ? ' in ' : ''
                } ${home.locationText || ''}`;
        }

        // temp unicode fix for import issue in WGLDE-1951
        // TODO: remove end of 2023
        typeAndLocationText = typeAndLocationText
            .replaceAll("Ã¼", 'ü')
            .replaceAll("Ã£", 'ä')
            .replaceAll("Ãµ", 'ö')
            .replaceAll("ÃŸ", 'ß');

        const isAffiliate = home.affiliates.includes(browserAffiliate ? browserAffiliate : user.affiliateName);

        return (
            <div className={styles.homeCardSmall + ' ' + (isActive ? styles.active : '')}>
                <div className="property property--dashboard">
                    <div className="property__image">
                        {home.image.path && isVisible ? (
                            home.offMarket ? (
                                <OffMarketSvg width="480" height="270" />
                            ) : (
                                <img className="img" src={baseUrl + home.image.path} alt={''} width="480" height="270" />
                            )
                        ) : (
                            <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg=="
                                className="img"
                                width="480"
                                height="270"
                            />
                        )}
                        {home.exclusive && (
                            <div className={styles.propertyMarker}>
                                <div className="marker marker--small marker--exclusive">
                                    <div className="marker__text">Exklusive Immobilie</div>
                                </div>
                            </div>
                        )}
                        {home.offMarket && (
                            <div className={styles.propertyMarker}>
                                <div className="marker marker--small marker--off-market">
                                    <div className="marker__text">off-market</div>
                                </div>
                            </div>
                        )}
                        {isAffiliate && (
                            <div className={styles.propertyMarker}>
                                <span />
                                <div className={styles.affiliate}>Dein Wohnglück-Partner</div>
                            </div>
                        )}
                    </div>

                    <div className="property__content">
                        <div className="property__data">
                            <div className={styles.propertyDataEntry}>
                                {!home.priceOnDemand && <div className={styles.propertyDataValue}>{Translate.getNumber(home.price) || '-'} €</div>}
                                {home.priceOnDemand && <div className={styles.propertyDataValue}>Auf Anfrage</div>}{' '}
                                <div className={styles.propertyDataLabel}>{home.priceLabel}</div>
                            </div>
                            {(home.propertyType === 'apartment' || home.propertyType === 'house') ?
                                <div className={styles.propertyDataEntry}>
                                    <div className={styles.propertyDataValue}>
                                        {home.livingArea ? Translate.getNumber(home.livingArea) + ' m²' : placeholder}
                                    </div>
                                    <div className={styles.propertyDataLabel}>Wohnfläche</div>
                                </div>
                                : home.usefulArea ?
                                    <div className={styles.propertyDataEntry}>
                                        <div className={styles.propertyDataValue}>
                                            {home.usefulArea ? Translate.getNumber(home.usefulArea) + ' m²' : placeholder}
                                        </div>
                                        <div className={styles.propertyDataLabel}>Nutzfläche</div>
                                    </div>
                                    : home.plotArea ?
                                        <div className={styles.propertyDataEntry}>
                                            <div className={styles.propertyDataValue}>
                                                {home.plotArea ? Translate.getNumber(home.plotArea) + ' m²' : placeholder}
                                            </div>
                                            <div className={styles.propertyDataLabel}>Grundstücksfläche</div>
                                        </div> : null
                            }

                            {(home.chambers || (home.propertyType === 'apartment' || home.propertyType === 'house')) &&
                                <div className={styles.propertyDataEntry}>
                                    <div className={styles.propertyDataValue}>
                                        {home.chambers ? Translate.getNumber(home.chambers) : placeholder}
                                    </div>
                                    <div className={styles.propertyDataLabel}>Zimmer</div>
                                </div>}
                            <FavouriteIcon id={home.id} className={styles.favourite} />
                        </div>
                        <div className="property__location">{typeAndLocationText}</div>
                    </div>

                    <a href={baseUrl + '/property/' + home.id} onClick={this.handleHomeClick} className="property__link" />
                </div>
            </div>
        );
    }

    protected handleHomeClick = (ev: React.MouseEvent<HTMLAnchorElement>) => {
        ev.preventDefault();
        searchApi.setActive(this.props.data.id);
        location.href = ev.currentTarget.href;
    };
}

export default withUserHOC(HomeCardSmall);
